import { render, staticRenderFns } from "./register-modal.vue?vue&type=template&id=c00e0754&scoped=true&"
import script from "./register-modal.vue?vue&type=script&lang=js&"
export * from "./register-modal.vue?vue&type=script&lang=js&"
import style0 from "./register-modal.vue?vue&type=style&index=0&id=c00e0754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00e0754",
  null
  
)

export default component.exports